import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import Vue from 'vue';

Vue.use(VueVirtualScroller);
